import React from 'react';

const Payment = () => {
    return (
      <div>
        <h2>Payment system is coming soon!</h2>
      </div>
    );
};

export default Payment;